const Layout = () => import('@/layout/index.vue')

export default {
    path: '/tools',
    component: Layout,
    redirect: '/tools/h5link',
    name: 'tools',
    meta: {
        title: '工具',
        icon: 'tools'
    },
    children: [
        {
            path: 'h5link',
            name: 'ToolsH5link',
            component: () => import('@/views/tools/h5link/index.vue'),
            meta: {
                title: 'H5链接生成',
                icon: 'tools-h5link',
                auth: ['tools']
            }
        }
    ]
}
